<template>
  <div class="iprdb_home_wrapper">
    <div id="home_container">
      <div class="m_main_header">
        <img
          src="../assets/images/index/logo_filled_fff.png"
          class="m_logo_size"
        />
        <!-- <img src="../assets/images/index/expand_icon.png" class="expanded" /> -->
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <div plain v-bind="attrs" v-on="on">
              <img
                src="../assets/images/index/expand_icon.png"
                class="expanded"
              />
            </div>
          </template>
          <v-list>
            <v-list-item-group v-model="userSel">
              <v-list-item v-for="(item, index) in userItems" :key="index">
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>
      <div class="home_header">
        <div class="header_wrapper">
          <div class="meun_box">
            <div class="meun_item logo1">
              <img src="../assets/images/common/logo1.svg" alt="" />
            </div>
            <div
              class="meun_item"
              :class="{ analysis_data: activeKey == 'index' }"
              @click="goAnchor('index')"
            >
              首页
            </div>
            <div
              class="meun_item"
              :class="{ analysis_data: activeKey == 'proStyle' }"
              @click="goAnchor('proStyle')"
            >
              产品特点
            </div>
            <div
              class="meun_item"
              :class="{ analysis_data: activeKey == 'proServer' }"
              @click="goAnchor('proServer')"
            >
              产品服务
            </div>
            <div
              class="meun_item"
              :class="{ analysis_data: activeKey == 'proApply' }"
              @click="goAnchor('proApply')"
            >
              场景化应用
            </div>
            <div
              class="meun_item"
              :class="{ analysis_data: activeKey == 'proVideo' }"
              @click="goAnchor('proVideo')"
            >
              培训视频
            </div>
            <div
              class="meun_item"
              :class="{ analysis_data: activeKey == 'proSell' }"
              @click="goAnchor('proSell')"
            >
              在线订购
            </div>
          </div>
          <div class="auth_box">
            <div class="auth_login" @click="goPage('login')">登录</div>
            <div class="auth_register" @click="goPage('login')">注册</div>
          </div>
        </div>
      </div>
      <div class="content" ref="index">
        <div class="panel1">
          <div class="p1_title">
            <span class="p1_content">7</span>天【无限次免费】查询专利
          </div>
          <!-- <div class="p1_content">9种检索方式，115个国家/地区，1.6亿专利数据</div> -->
          <!-- <div class="p1_content">9种检索方式，13万平台用户,1.6亿专利数据,105个国家50个行业+......(实力证明)</div> -->
          <div class="p1_content">
            <span class="titleh2">9</span>种检索方式<span class="titleh2"
              >13</span
            >万平台用户<span class="titleh2">1.6</span>亿专利数据<span
              class="titleh2"
              >105</span
            >个国家
            <span class="titleh2">50</span>

            个行业
          </div>

          <div class="p1_btn_box">
            <div class="free_try_btn">免费试用</div>
            <div class="intro_btn">一分钟学习</div>
          </div>
        </div>
        <div class="panel2" ref="proStyle">
          <div class="panel_title padding_t96 col">
            <img
              src="../assets/images/index/title_decorate_left.png"
              class="mar_r16 decorate_left_size"
            />
            产品特点
            <img
              src="../assets/images/index/title_decorate_right.png"
              class="mar_l16 decorate_left_size"
            />
          </div>
          <div class="m_p2_content">
            <div class="m_p2_wraooer">
              <div class="p2_item">
                <div class="p2_icon_wrapper">
                  <img src="../assets/images/index/quick_search.png" />
                </div>
                <div class="p2_item_title">与专利技术轻松对话的快速检索</div>
                <div class="underline line1"></div>
                <div class="p2_item_content_txt margin_top_adjust">
                  <span class="scaleFont">
                    用户输入一段话，即可精确匹配公开此技术的在先专利。iprdb利用自然语言处理、人工智能技术，创建了专利DNA图谱比对方法，抽取发明的核心部件及关系，在专利的文章级别、段落级别、词级别、语义级别进行大规模精准计算，新颖性检索和无效检索的准确性获得革命性提升。
                  </span>
                </div>
              </div>
            </div>
            <div class="m_p2_wraooer">
              <div class="p2_item">
                <div class="p2_icon_wrapper">
                  <img src="../assets/images/index/light.png" />
                </div>
                <div class="p2_item_title">洞悉国外顶尖技术的中文检索</div>
                <div class="underline line1"></div>

                <div class="p2_item_content_txt">
                  <span class="scaleFont">
                    iprdb对全球专利均提供了中英双语的标题和摘要，中国、美国、俄罗斯、德国、苏联等重要国家提供中英双语的全文信息，支持中文、英文和小语种检索全球专利，语言不再是用户获取专利智慧的障碍。
                  </span>
                </div>
              </div>
            </div>

            <div class="m_p2_wraooer">
              <div class="p2_item">
                <div class="p2_icon_wrapper">
                  <img src="../assets/images/index/line_chart.png" />
                </div>
                <div class="p2_item_title">快速更新的全球专利数据</div>
                <div class="underline line1"></div>
                <div class="p2_item_content_txt">
                  <span class="scaleFont">
                    iprdb收录了全球120个国家/组织/地区1亿余件专利信息。数据采购自各国知识产权官方和商业机构，全球专利信息每周更新四次，更新速度全球领先，助您第一时间掌握最新技术。
                  </span>
                </div>
              </div>
            </div>
            <div class="m_p2_wraooer">
              <div class="p2_item">
                <div class="p2_icon_wrapper">
                  <img src="../assets/images/index/controller.png" />
                </div>
                <div class="p2_item_title">深入加工的多维度特色数据</div>
                <div class="underline line1"></div>
                <!-- <div class="underline"></div> -->
                <div class="p2_item_content_txt">
                  <span class="scaleFont">
                    iprdb通过全面的数据整合加工，可以检索的字段达到260多个，融合了专利诉讼、转让、许可、复审无效、通信标准声明、海关备案信息，并深度加工了一系列专利同族引证信息，可以帮助您得到更清晰的竞争视野。
                  </span>
                </div>
              </div>
            </div>
            <div class="m_p2_wraooer">
              <div class="p2_item">
                <div class="p2_icon_wrapper">
                  <img src="../assets/images/index/submarine.png" />
                </div>
                <div class="p2_item_title">全面科学的同族库检索和统计</div>
                <div class="underline line1"></div>
                <!-- <div class="underline"></div> -->
                <div class="p2_item_content_txt">
                  <span class="scaleFont">
                    系统支持在原始文献数据库和同族数据库间切换检索。在同族数据库中检索，专利家族各成员的标题、摘要、专利权人等信息高度融合互补，检索结果更全面；在同族数据库中浏览，相同发明合并为一个文件，阅读更清晰；在同族库中统计和分析，一个专利族仅统计一次，结果更科学。
                  </span>
                </div>
              </div>
            </div>
            <div class="m_p2_wraooer">
              <div class="p2_item">
                <div class="p2_icon_wrapper">
                  <img src="../assets/images/index/marine.png" />
                </div>
                <div class="p2_item_title">挖掘数据价值的多维数据分析</div>
                <div class="underline line1"></div>
                <!-- <div class="underline"></div> -->
                <div class="p2_item_content_txt">
                  <span class="scaleFont">
                    用户输入一段话，即可精确匹配公开此技术的在先专利。iprdb利用自然语言处理、人工智能技术，创建了专利DNA图谱比对方法，抽取发明的核心部件及关系，在专利的文章级别、段落级别、词级别、语义级别进行大规模精准计算，新颖性检索和无效检索的准确性获得革命性提升。
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- pc -->
          <div class="p2_content mar_t134">
            <div class="p2_item">
              <div class="p2_icon_wrapper">
                <img src="../assets/images/index/quick_search.png" />
              </div>
              <div class="p2_item_title">与专利技术轻松对话的快速检索</div>
              <div class="underline"></div>
              <div class="p2_item_content_txt">
                用户输入一段话，即可精确匹配公开此技术的在先专利。iprdb利用自然语言处理、人工智能技术，创建了专利DNA图谱比对方法，抽取发明的核心部件及关系，在专利的文章级别、段落级别、词级别、语义级别进行大规模精准计算，新颖性检索和无效检索的准确性获得革命性提升。
              </div>
            </div>
            <div class="p2_item">
              <div class="p2_icon_wrapper">
                <img src="../assets/images/index/light.png" />
              </div>
              <div class="p2_item_title">洞悉国外顶尖技术的中文检索</div>
              <div class="underline"></div>
              <div class="p2_item_content_txt">
                iprdb对全球专利均提供了中英双语的标题和摘要，中国、美国、俄罗斯、德国、苏联等重要国家提供中英双语的全文信息，支持中文、英文和小语种检索全球专利，语言不再是用户获取专利智慧的障碍。
              </div>
            </div>
            <div class="p2_item">
              <div class="p2_icon_wrapper">
                <img src="../assets/images/index/line_chart.png" />
              </div>
              <div class="p2_item_title">快速更新的全球专利数据</div>
              <div class="underline"></div>
              <div class="p2_item_content_txt">
                iprdb收录了全球120个国家/组织/地区1亿余件专利信息。数据采购自各国知识产权官方和商业机构，全球专利信息每周更新四次，更新速度全球领先，助您第一时间掌握最新技术。
              </div>
            </div>
          </div>
          <div class="p2_content">
            <div class="p2_item">
              <div class="p2_icon_wrapper">
                <img src="../assets/images/index/controller.png" />
              </div>
              <div class="p2_item_title">深入加工的多维度特色数据</div>
              <div class="underline"></div>
              <div class="p2_item_content_txt">
                iprdb通过全面的数据整合加工，可以检索的字段达到260多个，融合了专利诉讼、转让、许可、复审无效、通信标准声明、海关备案信息，并深度加工了一系列专利同族引证信息，可以帮助您得到更清晰的竞争视野。
              </div>
            </div>
            <div class="p2_item">
              <div class="p2_icon_wrapper">
                <img src="../assets/images/index/submarine.png" />
              </div>
              <div class="p2_item_title">全面科学的同族库检索和统计</div>
              <div class="underline"></div>
              <div class="p2_item_content_txt">
                系统支持在原始文献数据库和同族数据库间切换检索。在同族数据库中检索，专利家族各成员的标题、摘要、专利权人等信息高度融合互补，检索结果更全面；在同族数据库中浏览，相同发明合并为一个文件，阅读更清晰；在同族库中统计和分析，一个专利族仅统计一次，结果更科学。
              </div>
            </div>
            <div class="p2_item">
              <div class="p2_icon_wrapper">
                <img src="../assets/images/index/marine.png" />
              </div>
              <div class="p2_item_title">挖掘数据价值的多维数据分析</div>
              <div class="underline"></div>
              <div class="p2_item_content_txt">
                用户输入一段话，即可精确匹配公开此技术的在先专利。iprdb利用自然语言处理、人工智能技术，创建了专利DNA图谱比对方法，抽取发明的核心部件及关系，在专利的文章级别、段落级别、词级别、语义级别进行大规模精准计算，新颖性检索和无效检索的准确性获得革命性提升。
              </div>
            </div>
          </div>
        </div>
        <div class="panel3" ref="proServer">
          <div class="panel_title margin_b95 mar_t95 color_f">
            <img
              src="../assets/images/index/title_decorate_left.png"
              class="mar_r16 decorate_left_size"
            />
            产品服务
            <img
              src="../assets/images/index/title_decorate_right.png"
              class="mar_l16 decorate_left_size"
            />
          </div>
          <div class="service_flag_wrapper">
            <img src="../assets/images/index/flag.png" />
          </div>
          <div class="m_p3_content mar_t36">
            <div class="p3_item">
              <div class="p3_item_title">全球专利数据库</div>
              <div class="underline mar_l65"></div>
              <div class="p3_item_content_txt mar_l65">
                <span>
                  1.5亿全球专利数据，覆盖116个国家/地区，提供精准，多维度，可视化的专利及研发情报。
                </span>
              </div>
              <div class="quick_try_btn mar_l65">
                <span class="m_font_fix"> 立即试用 </span>
              </div>
            </div>
          </div>
          <div class="m_p3_content">
            <div class="p3_item">
              <div class="p3_item_title">知识产权管理系统</div>
              <div class="underline mar_l65"></div>
              <div class="p3_item_content_txt mar_l65">
                <span>
                  针对信息，流程，文档，费用，期限等，为客户提供智能化，标准化，高安全的全流程管理服务。
                </span>
              </div>
              <div class="quick_try_btn mar_l65">
                <span class="m_font_fix"> 立即试用 </span>
              </div>
            </div>
          </div>
          <div class="m_p3_content">
            <div class="p3_item">
              <div class="p3_item_title">知识产权咨询服务</div>
              <div class="underline mar_l65"></div>
              <div class="p3_item_content_txt mar_l65">
                <span>
                  为企业/政府/高校提供一站式可落地的专利导航，专利布局，行业专题库等服务
                </span>
              </div>
              <div class="quick_try_btn mar_l65">
                <span class="m_font_fix"> 立即试用 </span>
              </div>
            </div>
          </div>
          <div class="m_p3_content">
            <div class="p3_item">
              <div class="p3_item_title">专利分析系统</div>
              <div class="underline mar_l65"></div>
              <div class="p3_item_content_txt mar_l65">
                <!-- <div class="p3_item_content_txt "> -->
                <span> 一键生成数据报告，即可获取价值情报 </span>
              </div>
              <div class="quick_try_btn mar_l65 mar_t20">
                <span class="m_font_fix"> 立即试用 </span>
              </div>
            </div>
          </div>
          <!-- pc -->
          <div class="p3_content mar_t41">
            <div class="p3_item">
              <div class="p3_item_title">全球专利数据库</div>
              <div class="underline mar_l65"></div>
              <div class="p3_item_content_txt">
                1.5亿全球专利数据，覆盖116个国家/地区，提供精准，多维度，可视化的专利及研发情报。
              </div>
              <div class="quick_try_btn mar_l65">立即试用</div>
            </div>
            <div class="p3_item">
              <div class="p3_item_title">知识产权管理系统</div>
              <div class="underline mar_l65"></div>
              <div class="p3_item_content_txt">
                针对信息，流程，文档，费用，期限等，为客户提供智能化，标准化，高安全的全流程管理服务。
              </div>
              <div class="quick_try_btn mar_l65">立即试用</div>
            </div>
          </div>
          <div class="p3_content mar_b134">
            <div class="p3_item">
              <div class="p3_item_title">知识产权咨询服务</div>
              <div class="underline mar_l65"></div>
              <div class="p3_item_content_txt">
                为企业/政府/高校提供一站式可落地的专利导航，专利布局，行业专题库等服务
              </div>
              <div class="quick_try_btn mar_l65">立即试用</div>
            </div>
            <div class="p3_item">
              <div class="p3_item_title">专利分析系统</div>
              <div class="underline mar_l65"></div>
              <div class="p3_item_content_txt">
                一键生成数据报告，即可获取价值情报
                <div></div>
              </div>
              <div class="quick_try_btn mar_l65 mar_t35">立即试用</div>
            </div>
          </div>
        </div>

        <div class="panel4" ref="proApply">
          <div class="panel_title padding_t102 padding_b134">
            <img
              src="../assets/images/index/title_decorate_left.png"
              class="mar_r16 decorate_left_size"
            />
            场景化应用
            <img
              src="../assets/images/index/title_decorate_right.png"
              class="mar_l16 decorate_left_size"
            />
          </div>
          <div class="m_panel4_box1">
            <div class="mar_r10">
              <img
                src="../assets/images/index/panel4_1.png"
                class="panel4_1_img_size"
              />
            </div>
            <div class="panel4_content mar_l10">
              <div class="panel4_box_title">提高创新效率</div>
              <div class="panel4_underline"></div>
              <div class="panel4_content_txt">
                企业在创新过程中，需要寻找发明的灵感，站在全球顶尖发明的基础上进行研究，用iprdb在全球范围内搜索顶尖智慧，可以避免重复研发，提高研发的起点和创新的效率。
              </div>
            </div>
          </div>
          <div class="m_panel4_box1">
            <div class="panel4_content mar_r10">
              <div class="panel4_box_title">提升技术和专利竞争力</div>
              <div class="panel4_underline"></div>
              <div class="panel4_content_txt">
                企业可以利用iprdb掌握竞争对手的研发方向和专利布局，获得有效的竞争情报，为科学制定研发决策提供支持。基于对现有专利技术的研究分析，可以提升专利质量和竞争力。
              </div>
            </div>
            <div class="mar_l10">
              <img
                src="../assets/images/index/panel4_2.png"
                class="panel4_1_img_size"
              />
            </div>
          </div>
          <div class="m_panel4_box1">
            <div class="mar_r10">
              <img
                src="../assets/images/index/panel4_3.png"
                class="panel4_1_img_size"
              />
            </div>
            <div class="panel4_content mar_l10">
              <div class="panel4_box_title">进入海外市场</div>
              <div class="panel4_underline"></div>
              <div class="panel4_content_txt">
                在一带一路的战略中，中国企业走出去，需要规避海外的专利侵权风险，同时在海外获得专利权，赢得市场。通过iprdb可以掌握海外的专利情况，并获得专利侵权风险的警报，为拓展海外市场保驾护航。
              </div>
            </div>
          </div>
          <div class="panel4_box1">
            <div class="mar_r31">
              <img
                src="../assets/images/index/panel4_1.png"
                class="panel4_1_img_size"
              />
            </div>
            <div class="panel4_content">
              <div class="panel4_box_title">提高创新效率</div>
              <div class="panel4_underline"></div>
              <div class="panel4_content_txt">
                企业在创新过程中，需要寻找发明的灵感，站在全球顶尖发明的基础上进行研究，用iprdb在全球范围内搜索顶尖智慧，可以避免重复研发，提高研发的起点和创新的效率。
              </div>
            </div>
          </div>
          <div class="panel4_box1">
            <div class="panel4_content mar_r31">
              <div class="panel4_box_title">提升技术和专利竞争力</div>
              <div class="panel4_underline"></div>
              <div class="panel4_content_txt">
                企业可以利用iprdb掌握竞争对手的研发方向和专利布局，获得有效的竞争情报，为科学制定研发决策提供支持。基于对现有专利技术的研究分析，可以提升专利质量和竞争力。
              </div>
            </div>
            <div class="mar_l31">
              <img
                src="../assets/images/index/panel4_2.png"
                class="panel4_img_size"
              />
            </div>
          </div>
          <div class="panel4_box1">
            <div class="mar_r31">
              <img src="../assets/images/index/panel4_3.png" />
            </div>
            <div class="panel4_content">
              <div class="panel4_box_title">进入海外市场</div>
              <div class="panel4_underline"></div>
              <div class="panel4_content_txt">
                在一带一路的战略中，中国企业走出去，需要规避海外的专利侵权风险，同时在海外获得专利权，赢得市场。通过iprdb可以掌握海外的专利情况，并获得专利侵权风险的警报，为拓展海外市场保驾护航。
              </div>
            </div>
          </div>
        </div>
        <div class="panel5">
          <div class="panel_title padding_t96 color_f">
            <img
              src="../assets/images/index/title_decorate_left.png"
              class="mar_r16 decorate_left_size"
            />
            为什么企业会选择IPRDB
            <img
              src="../assets/images/index/title_decorate_right.png"
              class="mar_l16 decorate_left_size"
            />
          </div>
          <div class="panel5_content">
            <div class="panel5_item">
              <div class="top_pad"></div>
              <div class="panel5_item_num">1</div>
              <div class="panel_item_title">高效检索全球专利</div>
              <div class="panel_item_content">
                9种便捷的检索方式，帮助研发和IP从116个国家，超过1.5亿专利数据中快速找到准确信息。
              </div>
            </div>
            <div class="panel5_item">
              <div class="top_pad"></div>
              <div class="panel5_item_num">2</div>
              <div class="panel_item_title">掌握同行技术情报</div>
              <div class="panel_item_content">
                相似专利，同族专利，引用分析，法律信息等多维度数据，挖掘专利背后的技术情报
              </div>
            </div>
            <div class="panel5_item">
              <div class="top_pad"></div>
              <div class="panel5_item_num">3</div>
              <div class="panel_item_title">及时防范侵权风险</div>
              <div class="panel_item_content">
                监控全球范围内竞争对手专利，多达13种更新状况，高校掌握竞争对手的专利侵权及技术布局动态。
              </div>
            </div>
          </div>
        </div>
        <div class="m_panel6">
          <!-- <div class="panel6_head_box"> -->
          <div class="panel6_head_box padding_t43">
            <div class="panel6_item_wrapper">
              <div class="panel6_item">
                <div class="panel6_item_img">
                  <img src="../assets/images/index/panel6_1.png" />
                </div>
                <div class="panel6_txt">
                  数据全面可靠，更新及时，每条数据都经过严格的对比测试
                </div>
              </div>
            </div>
            <div class="panel6_item_wrapper">
              <div class="panel6_item">
                <div class="panel6_item_img">
                  <img src="../assets/images/index/panel6_2.png" />
                </div>
                <div class="panel6_txt">
                  支持中文检索全球专利，操作页面更符合中国用户习惯
                </div>
              </div>
            </div>
            <div class="panel6_item_wrapper">
              <div class="panel6_item">
                <div class="panel6_item_img">
                  <img src="../assets/images/index/panel6_3.png" />
                </div>
                <div class="panel6_txt">提供及时、稳定、一对一的本地化服务</div>
              </div>
            </div>
          </div>

          <div class="panel6_head_box second_line">
            <div class="panel6_item_wrapper">
              <div class="panel6_item">
                <div class="panel6_item_img">
                  <img src="../assets/images/index/panel6_4.png" />
                </div>
                <div class="panel6_txt">
                  数据全面可靠，更新及时，每条数据都经过严格的对比测试
                </div>
              </div>
            </div>
            <div class="panel6_item_wrapper">
              <div class="panel6_item">
                <div class="panel6_item_img">
                  <img src="../assets/images/index/panel6_5.png" />
                </div>
                <div class="panel6_txt">
                  用户数据存储于国内私有服务器，通过严密措施，保障信息安全
                </div>
              </div>
            </div>
          </div>
          <div class="panel6_2">
            <span class="panel6_num">13</span>万平台用户
            <span class="panel6_num">1.6</span>亿专利数据
          </div>
          <div class="panel6_3">
            覆盖 <span class="panel6_num">105</span>个国家<span
              class="panel6_num"
              >50</span
            >个行业+
            <div class="m_panel6_3_last_txt">......(实力证明）</div>
            <span class="panel6_3_last_txt">......(实力证明）</span>
          </div>
        </div>
        <div class="panel6">
          <div class="panel6_head_box">
            <div class="panel6_item">
              <div>
                <img src="../assets/images/index/panel6_1.png" />
              </div>
              <div class="panel6_txt">
                数据全面可靠，更新及时，每条数据都经过严格的对比测试
              </div>
            </div>
            <div class="panel6_item border_l0">
              <div>
                <img src="../assets/images/index/panel6_2.png" />
              </div>
              <div class="panel6_txt">
                支持中文检索全球专利，操作页面更符合中国用户习惯
              </div>
            </div>
            <div class="panel6_item border_l0">
              <div>
                <img src="../assets/images/index/panel6_3.png" />
              </div>
              <div class="panel6_txt">提供及时、稳定、一对一的本地化服务</div>
            </div>
            <div class="panel6_item border_l0">
              <div>
                <img src="../assets/images/index/panel6_4.png" />
              </div>
              <div class="panel6_txt">
                数据全面可靠，更新及时，每条数据都经过严格的对比测试
              </div>
            </div>
            <div class="panel6_item border_l0">
              <div>
                <img src="../assets/images/index/panel6_5.png" />
              </div>
              <div class="panel6_txt">
                用户数据存储于国内私有服务器，通过严密措施，保障信息安全
              </div>
            </div>
          </div>
          <div class="panel6_2">
            <span class="panel6_num">13</span>万平台用户
            <span class="panel6_num">1.6</span>亿专利数据
          </div>
          <div class="panel6_3">
            覆盖 <span class="panel6_num">105</span>个国家<span
              class="panel6_num"
              >50</span
            >个行业+
            <div class="m_panel6_3_last_txt">......(实力证明）</div>
            <span class="panel6_3_last_txt">......(实力证明）</span>
          </div>
        </div>
        <div class="panel7">
          合作方：眼谷 ，临港科技城，温州知产大港湾，今日头条
        </div>
        <div class="panel8" ref="proVideo">
          <div class="panel_title padding_t115 color_f">
            <img
              src="../assets/images/index/title_decorate_left.png"
              class="mar_r16 decorate_left_size"
            />
            培训视频
            <img
              src="../assets/images/index/title_decorate_right.png"
              class="mar_l16 decorate_left_size"
            />
          </div>
          <!-- <div class="m_banner_box">
                <el-carousel :interval="8888000" type="card" height="200px">
                    <el-carousel-item v-for="item in 4" :key="item">
                    <div class="medium">
                        <div class="video_wrapper">
                        <img src="../assets/images/index/logo.png" />
                        </div>
                        <div class="banner_title">专利检索视频</div>
                    </div>
                    </el-carousel-item>
                </el-carousel>
                </div> -->
          <div class="banner_box">
            <v-carousel>
              <v-carousel-item v-for="item in 6" :key="item">
                <div class="medium">
                  <div class="video_wrapper">
                    <img src="../assets/images/index/logo.png" />
                  </div>
                  <div class="banner_title">专利检索视频</div>
                </div>
                <!-- <v-sheet
                            :color="color"
                            height="100%"
                            tile
                        >
                            <v-row
                            class="fill-height"
                            align="center"
                            justify="center"
                            >
                            <div class="display-3">
                                Slide {{ i + 1 }}
                            </div>
                            </v-row>
                        </v-sheet> -->
              </v-carousel-item>
            </v-carousel>
            <!-- <el-carousel :interval="8888000" type="card" height="500px">
                    <el-carousel-item v-for="item in 6" :key="item">
                    <div class="medium">
                        <div class="video_wrapper">
                        <img src="../assets/images/index/logo.png" />
                        </div>
                        <div class="banner_title">专利检索视频</div>
                    </div>
                    </el-carousel-item>
                </el-carousel> -->
          </div>
          <div class="panel8_try_btn">试用申请</div>
        </div>
        <div class="m_panel9">
          <div class="panel8_box1 padding_t33">
            <div class="panel8_line1">
              <div class="panel8_title">希望使用的产品</div>
              <v-text-field
                class="panel8_input_sty"
                v-model="form.value1"
                label=""
                hide-details
                outlined
              ></v-text-field>
              <!-- <el-input v-model="value" class="panel8_input_sty"> </el-input> -->
            </div>
            <div class="panel8_line1">
              <div class="panel8_title">手机号</div>
              <v-text-field
                class="panel8_input_sty"
                v-model="form.value2"
                label=""
                hide-details
                outlined
              ></v-text-field>
              <!-- <el-input v-model="value" class="panel8_input_sty"> </el-input> -->
            </div>
            <!-- <div class="panel8_line1">
                    <div class="panel8_title">姓名</div>
                    <el-input v-model="value" class="panel8_input_sty"> </el-input>
                </div> -->
          </div>
          <div class="panel8_box1">
            <div class="panel8_line1">
              <div class="panel8_title">姓名</div>
              <v-text-field
                class="panel8_input_sty"
                v-model="form.value3"
                label=""
                hide-details
                outlined
              ></v-text-field>
              <!-- <el-input v-model="value" class="panel8_input_sty"> </el-input> -->
            </div>
            <div class="panel8_line1">
              <div class="panel8_title">邮箱</div>
              <v-text-field
                class="panel8_input_sty"
                v-model="form.value4"
                label=""
                hide-details
                outlined
              ></v-text-field>
              <!-- <el-input v-model="value" class="panel8_input_sty"> </el-input> -->
            </div>
            <!-- <div class="panel8_line1">
                    <div class="panel8_title">姓名</div>
                    <el-input v-model="value" class="panel8_input_sty"> </el-input>
                </div> -->
          </div>
          <div class="panel8_box1">
            <div class="panel8_line1">
              <div class="panel8_title">公司全称</div>
              <v-text-field
                class="panel8_input_sty"
                v-model="form.value5"
                label=""
                hide-details
                outlined
              ></v-text-field>
              <!-- <el-input v-model="value" class="panel8_input_sty"> </el-input> -->
            </div>
            <div class="panel8_line1">
              <div class="panel8_title">您的职位</div>
              <v-text-field
                class="panel8_input_sty"
                v-model="form.value5"
                label=""
                hide-details
                outlined
              ></v-text-field>
              <!-- <el-input v-model="value" class="panel8_input_sty"> </el-input> -->
            </div>
            <!-- <div class="panel8_line1">
                    <div class="panel8_title">您的职位</div>
                    <el-input v-model="value" class="panel8_input_sty"> </el-input>
                </div> -->
          </div>
          <div class="panel8_try_btn mar_t108">立即开通免费账号</div>
        </div>
        <!-- </div> -->
        <div class="panel9" ref="proSell">
          <div class="panel8_box1 mar_t108">
            <div class="panel8_line1">
              <div class="panel8_title">希望使用的产品</div>
              <v-text-field
                class="panel8_input_sty"
                v-model="form.value1"
                label=""
                height="36"
                hide-details
                outlined
              ></v-text-field>
              <!-- <el-input v-model="value" class="panel8_input_sty"> </el-input> -->
            </div>
            <div class="panel8_line1">
              <div class="panel8_title">手机号</div>
              <v-text-field
                class="panel8_input_sty"
                v-model="form.value2"
                label=""
                height="36"
                hide-details
                outlined
              ></v-text-field>
              <!-- <el-input v-model="value" class="panel8_input_sty"> </el-input> -->
            </div>
            <div class="panel8_line1">
              <div class="panel8_title">姓名</div>
              <v-text-field
                class="panel8_input_sty"
                v-model="form.value3"
                label=""
                height="36"
                hide-details
                outlined
              ></v-text-field>
              <!-- <el-input v-model="value" class="panel8_input_sty"> </el-input> -->
            </div>
          </div>
          <div class="panel8_box1 mar_84">
            <div class="panel8_line1">
              <div class="panel8_title">邮箱</div>
              <v-text-field
                class="panel8_input_sty"
                v-model="form.value4"
                label=""
                height="36"
                hide-details
                outlined
              ></v-text-field>
              <!-- <el-input v-model="value" class="panel8_input_sty"> </el-input> -->
            </div>
            <div class="panel8_line1">
              <div class="panel8_title">公司全称</div>
              <v-text-field
                class="panel8_input_sty"
                v-model="form.value5"
                label=""
                height="36"
                hide-details
                outlined
              ></v-text-field>
              <!-- <el-input v-model="value" class="panel8_input_sty"> </el-input> -->
            </div>
            <div class="panel8_line1">
              <div class="panel8_title">您的职位</div>
              <v-text-field
                class="panel8_input_sty"
                v-model="form.value6"
                label=""
                height="36"
                hide-details
                outlined
              ></v-text-field>
              <!-- <el-input v-model="value" class="panel8_input_sty"> </el-input> -->
            </div>
          </div>
          <div class="panel8_try_btn mar_t108">立即开通免费账号</div>
        </div>
      </div>
      <div class="panel10">
        <div class="panel10_wrapper">
          <div class="panel10_1">
            <img src="../assets/images/index/brand.png" />
          </div>
          <div class="panel10_2">
            <div class="font14">IPRDB产品</div>
            <div>快速检索</div>
            <div>高级检索</div>
            <div>知识产权管理系统</div>
            <div>工作时间</div>
            <div>专利导航</div>
            <div>行业专题库</div>
            <div>专利榜</div>
            <div>专利库</div>
            <div>专利百科</div>
          </div>
          <div class="panel10_3">
            <div class="font14">友情链接</div>
            <div>专利汇</div>
            <div>知嘟嘟</div>
          </div>
          <div class="panel10_4">
            <div class="font14">联系我们</div>
            <div>400-021-5055</div>
            <div>地址：上海市松江区新桥镇莘砖公路518号5幢3层</div>
          </div>
          <div class="m_panel10_5">
            <img src="../assets/images/index/qrcode.png" />
          </div>
          <div class="panel10_5">
            <img src="../assets/images/index/qrcode.png" />
          </div>
        </div>
      </div>
      <div class="footer">
        <span>
          ©2019-2020 上海吉码数字技术有 沪ICP备20016256号-1
          增值电信业务经营许可证：沪B2-20201290
        </span>
      </div>
      <div class="m_panel10">
        <div class="img_wrapper">
          <img src="../assets/images/index/brand.png" />
        </div>
        <div class="panel10_wrapper">
          <div class="panel10_2">
            <div class="font14">IPRDB产品</div>
            <div>快速检索</div>
            <div>高级检索</div>
            <div>知识产权管理系统</div>
            <div>工作时间</div>
            <div>专利导航</div>
            <div>行业专题库</div>
            <div>专利榜</div>
            <div>专利库</div>
            <div>专利百科</div>
          </div>
          <div class="panel10_3">
            <div class="font14">友情链接</div>
            <div>专利汇</div>
            <div>知嘟嘟</div>
          </div>
          <div class="panel10_4">
            <div class="font14">联系我们</div>
            <div>400-021-5055</div>
            <div>地址：上海市松江区新桥镇莘砖公路518号5幢3层</div>
          </div>
          <div class="m_panel10_5">
            <img src="../assets/images/index/qrcode.png" />
          </div>
          <div class="panel10_5">
            <img src="../assets/images/index/qrcode.png" />
          </div>
        </div>
      </div>
      <div class="m_footer">
        <div class="line">
          ©2019-2020 上海吉码数字技术有 沪ICP备20016256号-1
        </div>
        <div class="line">增值电信业务经营许可证：沪B2-20201290</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {},
      userItems: [
        {
          title: "注册",
        },
        {
          title: "登录",
        },
      ],
      userSel: "",
      activeKey: "index",
    };
  },
  watch: {
    userSel(val) {
      this.$router.push({
        path: "/login",
      });
    },
  },
  methods: {
    goPage(val) {
      let path = val;
      this.$router.push({
        path: "/" + path,
      });
    },
    goAnchor(key) {
      this.activeKey = key;
      this.$refs[key].scrollIntoView();
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 768px) {
  html {
    overflow: hidden;
  }
}
</style>
